import React from "react";
import Sense from "../../assets/packky_works_1.webp";
import Trends from "../../assets/packky_works_2.webp";

const PackkyWorks = () => {
  return (
    <section className="py-5">
      <div className="mx-auto w-full max-w-7xl px-4">
        {/* Heading */}
        <div className="flex justify-center">
          <div className="w-full mt-8 md:w-10/12 lg:w-8/12 md:h-[95%] text-center mb-5">
        <h3 className="mb-3 text-[#212529] text-[24px] sm:text-[26px] md:text-[28px] lg:text-[28px] font-bold leading-tight tracking-tight font-sf text-center">
  How Packky Works
</h3>
           <span className="text-[14px] sm:text-[15px] md:text-[18px] lg:text-[20px] font-normal text-gray-500 leading-6 font-sf">
  Simple tools. Smart deliveries. For any business.
</span>
          </div>
        </div>

        {/* Cards */}
    <div className="mt-6 flex flex-wrap justify-center gap-4">
          {/* First Card */}
       <div className="flex w-full md:w-[45%] lg:w-5/12">
            <div
              className="card flex h-full w-full flex-col rounded-2xl border-0 p-3 md:p-3 lg:p-4"
              style={{
                backgroundImage:
                  "linear-gradient(to top right, #468dff, #c1f1f7)",
              }}
            >
           <div className="mb-3 overflow-hidden rounded-2xl h-[220px] sm:h-[260px] md:h-[220px] lg:h-[300px]">
                <img
                  src={Sense}
                  className="w-full h-full"
                  alt="From Kitchen to Customer"
                  style={{ objectFit: "cover" }}
                />
              </div>

              <div className="card-body-packky bg-white rounded-2xl p-3 md:p-3 lg:p-4 flex flex-col flex-grow min-h-[250px] md:min-h-[280px] lg:min-h-[220px]">
                <h5
                  className="mb-3 text-left"
                  style={{
                    color: "#212529",
                    fontWeight: "700",
                    fontSize: "clamp(20px, 2vw, 24px)",
                  }}
                >
                  From Pickup to Drop — Simplified!
                </h5>

                <p className="mb-0 text-left text-[14px] sm:text-[15px] md:text-[16px] leading-6 text-[#6b6b6b] font-sf">
                  Packky (powered by Chaafo) helps you manage every step of your
                  delivery with ease. Just enter the pickup and drop locations,
                  add parcel details, and we’ll take care of the rest. Our system
                  automatically calculates the best route and assigns the right
                  vehicle — making sure your delivery is smooth, fast, and right
                  on time.
                </p>
              </div>
            </div>
          </div>

          {/* Second Card */}
       <div className="flex w-full md:w-[45%] lg:w-5/12">
            <div
              className="card flex h-full w-full flex-col rounded-2xl border-0 p-3 md:p-3 lg:p-4"
              style={{
                backgroundImage:
                  "linear-gradient(to top right, #ffa500, #f9e6c2)",
              }}
            >
              <div className="mb-3 overflow-hidden rounded-2xl h-[220px] sm:h-[260px] md:h-[220px] lg:h-[300px]">
                <img
                  src={Trends}
                  className="w-full h-full"
                  alt="Built for Every Restaurant"
                />
              </div>

             <div className="card-body-packky bg-white rounded-2xl p-3 md:p-3 lg:p-4 flex flex-col flex-grow min-h-[240px] md:min-h-[280px] lg:min-h-[220px]">
                <h5
                  className="mb-3 text-left"
                  style={{
                    color: "#212529",
                    fontWeight: "700",
                    fontSize: "clamp(20px, 2vw, 24px)",
                  }}
                >
                  Built for All Business Types
                </h5>

                <p className="mb-0 text-left text-[14px] sm:text-[15px] md:text-[16px] leading-6 text-[#6b6b6b] font-sf">
                  Whether you run a General store, distribute goods to retailers,
                  or manage a local service business, Packky (powered by Chaafo)
                  adapts to your needs. You can send stock to vendors, deliver
                  orders to customers, or handle internal branch transfers — all
                  while tracking everything live and managing your operations in
                  one place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackkyWorks;